module.exports = __webpack_public_path__ + "img/mizrachi-large.5dd1df5f.svg";